import styled from 'styled-components';

export const UnregisteredStep1Style = styled.div`
  .unregister-logo {
    margin: 0 auto;
    margin-bottom: 32px;
    max-width: 220px;
  }
`;
